import { render } from "./text-link.vue?vue&type=template&id=240bd127"
import script from "./text-link.vue?vue&type=script&lang=js"
export * from "./text-link.vue?vue&type=script&lang=js"

import "./text-link.vue?vue&type=style&index=0&id=240bd127&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__